import { render, staticRenderFns } from "./useCouponRecord.vue?vue&type=template&id=9ef4abea&scoped=true&"
import script from "./useCouponRecord.vue?vue&type=script&lang=js&"
export * from "./useCouponRecord.vue?vue&type=script&lang=js&"
import style0 from "./useCouponRecord.vue?vue&type=style&index=0&id=9ef4abea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef4abea",
  null
  
)

export default component.exports